var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 16.666H4.99935C4.11529 16.666 3.26745 16.3148 2.64233 15.6897C2.01721 15.0646 1.66602 14.2167 1.66602 13.3327V5.83268C1.66602 4.94863 2.01721 4.10078 2.64233 3.47566C3.26745 2.85054 4.11529 2.49935 4.99935 2.49935H14.166C15.0501 2.49935 15.8979 2.85054 16.523 3.47566C17.1482 4.10078 17.4993 4.94863 17.4993 5.83268V8.33268M6.66602 1.66602V3.33268M12.4993 1.66602V3.33268M1.66602 6.66602H17.4993M15.416 13.0352L14.166 14.2852",
    stroke: "white",
    strokeWidth: 1.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333C16.4679 18.3333 18.3333 16.4679 18.3333 14.1667C18.3333 11.8655 16.4679 10 14.1667 10C11.8655 10 10 11.8655 10 14.1667C10 16.4679 11.8655 18.3333 14.1667 18.3333Z",
    stroke: "white",
    strokeWidth: 1.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.d8b1053e8cbb2db1c7081e1b86009756.svg";
export { ForwardRef as ReactComponent };